var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2004_41566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23742 7.50022L13.7439 1.99438C14.0857 1.65257 14.0857 1.09838 13.7439 0.756602C13.4021 0.414792 12.8479 0.414792 12.5061 0.756602L7.00022 6.26302L1.49438 0.756602C1.15257 0.414792 0.598385 0.414792 0.256602 0.756602C-0.0851811 1.09841 -0.0852084 1.65259 0.256602 1.99438L5.76302 7.50022L0.256602 13.0061C-0.0852084 13.3479 -0.0852084 13.9021 0.256602 14.2439C0.598412 14.5857 1.15259 14.5857 1.49438 14.2439L7.00022 8.73742L12.5061 14.2439C12.8479 14.5857 13.4021 14.5857 13.7438 14.2439C14.0857 13.9021 14.0857 13.3479 13.7438 13.0061L8.23742 7.50022Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2004_41566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.7d2745b75a54b59fda385b5a8fac71ae.svg";
export { ForwardRef as ReactComponent };